// Page removed per request
export default function AdminReports() { return null; }